import { gql, useQuery } from '@apollo/client';
import { FILE_FIELDS_FRAGMENT, SEO_FIELDS_FRAGMENT } from '../fragments';
import { CollectionResponse } from '../types';
import { InsightArticle } from './types';

interface QueryResult {
  insightArticles: CollectionResponse<InsightArticle>;
}

export function useArticle(slug: string) {
  return useQuery<QueryResult>(query, { variables: { slug } });
}

const query = gql`
  ${FILE_FIELDS_FRAGMENT}
  ${SEO_FIELDS_FRAGMENT}
  query GetInsight($slug: String) {
    insightArticles(filters: { Slug: { eq: $slug } }) {
      data {
        id
        attributes {
          SEO {
            ...SEOFields
          }
          Title
          Slug
          PublishDate
          ArticleCopy
          insight_tags {
            data {
              id
              attributes {
                tag
              }
            }
          }
          employee {
            data {
              id
              attributes {
                name
                bio
                AuthorContactInfo {
                  id
                  ContactLink
                  ContactText
                }
                photo {
                  data {
                    ...FileFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
